import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-G267Z2DPVX'); // Replace 'G-XXXXXXXXXX' with your Measurement ID
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};